import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment to control whether or not we should prefetch the PDP endpoints on touch for mobile web
 */
export const PDP_PREFETCH_ON_TOUCH_XP_250416 =
  'PDP_PREFETCH_ON_TOUCH_XP_250416' as SettingConst<
    'PDP_PREFETCH_ON_TOUCH_XP_250416',
    boolean,
    never
  >;
